import type { ICalendarEvent } from '@/features/calendar/interfaces'

import { differenceInDays, endOfDay, isWithinInterval, parseISO, startOfDay } from 'date-fns'

import { MonthTrainingBadge } from '@/features/calendar/components/month-view/month-event-badge'

interface IProps {
  selectedDate: Date
  multiDayTrainings: ICalendarEvent[]
}

export function DayViewMultiDayEventsRow({ selectedDate, multiDayTrainings }: IProps) {
  const dayStart = startOfDay(selectedDate)
  const dayEnd = endOfDay(selectedDate)

  const multiDayTrainingsInDay = multiDayTrainings
    .filter((training) => {
      const trainingStart = parseISO(training.startAt)
      const trainingEnd = parseISO(training.endAt)

      const isOverlapping
        = isWithinInterval(dayStart, { start: trainingStart, end: trainingEnd })
        || isWithinInterval(dayEnd, { start: trainingStart, end: trainingEnd })
        || (trainingStart <= dayStart && trainingEnd >= dayEnd)

      return isOverlapping
    })
    .sort((a, b) => {
      const durationA = differenceInDays(parseISO(a.endAt), parseISO(a.startAt))
      const durationB = differenceInDays(parseISO(b.endAt), parseISO(b.startAt))
      return durationB - durationA
    })

  if (multiDayTrainingsInDay.length === 0) {
    return null
  }

  return (
    <div className="flex border-b">
      <div className="w-18"></div>
      <div className="flex flex-1 flex-col gap-1 border-l py-1">
        {
          multiDayTrainingsInDay.map((training) => {
            const trainingStart = startOfDay(parseISO(training.startAt))
            const trainingEnd = startOfDay(parseISO(training.endAt))
            const currentDate = startOfDay(selectedDate)

            const trainingTotalDays = differenceInDays(trainingEnd, trainingStart) + 1
            const trainingCurrentDay = differenceInDays(currentDate, trainingStart) + 1

            return <MonthTrainingBadge key={training.id} training={training} cellDate={selectedDate} trainingCurrentDay={trainingCurrentDay} trainingTotalDays={trainingTotalDays} />
          })
        }
      </div>
    </div>
  )
}
